/** 保存表单接口 */

import { Result } from '@/typings';
import { handleResult, post } from '@/util';

/** 升级申请信息列表数据 */
export type TableData = {
	/** 主键 */
	id?: string;
	/** 用户名 */
	name?: string;
	/** 公司名 */
	company?: string;
	/** 邮箱 */
	email?: string;
	/** 申请时间 */
	createTime?: string;
	/** 手机号 */
	phoneNumber?: string;
	/** 微信号 */
	wechatId?: string;
	/** 是否已联系 */
	isContact?: string;
};

/** 版本用量列表数据 */
export type VersionUsage = {
	/** 主键 */
	id?: string;
	/** 用户 */
	userId?: string;
	/** 版本类型 */
	versionType?: string;
	/** 每日剩余会话次数 */
	requestCount?: number;
	/** 每日会话次数 */
	totalRequestCount?: number;
	/** 深度探索次数 */
	searchCount?: number;
	/** 每日深度探索次数 */
	totalSearcCount?: number;
	/** 奖励的请求次数 */
	additionalRequestCount?: number;
	/** 文件个数 */
	fileCount?: number;
	/** 每日文件上传个数 */
	totalFileCount?: number;
	/** 知识库剩余容量 */
	fileSize?: number;
	/** 知识库容量 */
	totalFileSize?: number;
	/** 网页访问量 */
	viewableSearchResult?: number;
	/** 实体对比次数 */
	entityComparisonCount?: number;
	/** 自定义分析次数 */
	customAnalysisCount?: number;
	/** 网页访问量 */
	viewableSearchResults?: number;
};

export const saveUpgradeInfo = (params: TableData) => {
	return new Promise<boolean>((resolve, reject) => {
		post(
			'/app/upgrade-info/save',
			{ ...params, baseURL: '/server', headers: { showLoading: true, message: '正在提交数据，请稍后...' } },
			(result: Result<boolean>) => {
				handleResult(
					result,
					() => resolve(true),
					() => resolve(false),
				);
			},
			reject,
		);
	});
};
